import React from 'react';
import '../styles/style.css';

const Background = () => {
  return (
    <div className="background">
      <div className="circle circle1"></div>
      <div className="circle circle2"></div>
      <div className="circle circle3"></div>
    </div>
  );
};

export default Background;
